export default class GoogleSlideApi {
    CLIENT_ID;
    API_KEY;
    DISCOVERY_DOCS;
    SCOPES;
    successCall;
    failCall;
    retryCall;
    constructor(successCall, failCall, retryCall) {
        this.CLIENT_ID = "735969725625-iqd7jqb8l1shdrvuv01b57sk871nlj1r.apps.googleusercontent.com";
        this.API_KEY = "AIzaSyB-n7tHYxj7ktDllL8uljclzMJUz4gf0s4";

        this.DISCOVERY_DOCS = ["https://slides.googleapis.com/$discovery/rest?version=v1"];
        this.SCOPES = "https://www.googleapis.com/auth/presentations";
        this.successCall = successCall;
        this.failCall = failCall;
        this.retryCall = retryCall;
        this.setLogin();
    }
    createSlide(slideData) {
        gapi.client.slides.presentations
            .create({
                title: slideData["title"],
            })
            .then((response) => {
                console.log(`Created presentation with ID: ${response.result.presentationId}`);
                let pageID = response.result.slides[0].objectId;
                let request = slideData["request"];
                request[0]["deleteObject"].objectId = pageID;
                gapi.client.slides.presentations
                    .batchUpdate({
                        presentationId: response.result.presentationId,
                        requests: request,
                    })
                    .then((res) => {
                        res.result.replies[0].createShape;
                        this.successCall();
                    });
            });
    }
    setLogin() {
        let initClient = () => {
            gapi.client
                .init({
                    apiKey: this.API_KEY,
                    clientId: this.CLIENT_ID,
                    discoveryDocs: this.DISCOVERY_DOCS,
                    scope: this.SCOPES,
                })
                .then(
                    () => {
                        gapi.auth2.getAuthInstance().isSignedIn.listen(this.retryCall);
                        this.signIn(gapi.auth2.getAuthInstance().isSignedIn.get());
                    },
                    (error) => {
                        console.log(JSON.stringify(error, null, 2));
                    }
                );
        };
        gapi.load("client:auth2", initClient);
    }
    signIn(flag) {
        if (flag) {
            // login google success
            this.retryCall();
        } else {
            this.failCall && this.failCall();
        }
    }
    checkLogin() {
        if (gapi.auth2 && !gapi.auth2.getAuthInstance().isSignedIn.get()) {
            gapi.auth2.getAuthInstance().signIn();
        }
        return gapi.auth2 && gapi.auth2.getAuthInstance().isSignedIn.get();
    }
    sendSlide(obj) {
        this.createSlide(obj);
    }
}
